import './VideoState.scss';
import { VideoStateParams } from './VideoState.type';

export default function VideoState(props: VideoStateParams) {
  const { mode = 'small', on = false } = props;
  const state = on ? 'on' : 'off';

  return (
    <span className={`video-state video-state--${mode}`}>
      <i className={`video-state__icon--${state}`} />
    </span>
  );
}
